<template>
  <div>
    <el-drawer
    :title="$t('other.a3087')"
    :visible.sync="showDrawer"
    :direction="direction"
    >
    <div class="joinvd" v-if="!show">
        <div class="ijsfd"><i class="el-icon-loading"></i></div>
        <h4>{{$t('other.a3088')}}</h4>
    </div>
    <Result v-else :resultData="resultData"></Result>
    </el-drawer>
  </div>
</template>

<script>
import Result from './resultSubmint'
export default {
data(){
return{
    showDrawer:false,
    show:false
}
},
props:{
    resultData: {
      type: Array,
      default: () => {}
    }
},
watch:{
    resultData(){
        if(this.resultData.length > 0){
            this.show=true
        }
    }
},
components:{
    Result
},
created(){

},
methods:{

}
}

</script>
<style scoped>
.el-icon-loading{
    font-size: 35px;
}

.joinvd{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 120px;
}

.ijsfd{
    margin-bottom: 30px;
}
</style>